<template>
  <div>
    <InputLabel
      v-if="label"
      :label="label"
      :required="required"
    />
    <div class="card-input__options-wrapper">
      <CardWrapper
        v-for="{ label: optionLabel, value: valueOption } in options"
        :key="optionLabel"
        :actionable="false"
        border-radius="small"
        :disabled="disabled"
        :is-selected="selectedItems.includes(valueOption)"
        padding="medium"
        selectable
        @update:selected="handleSelection(valueOption)"
      >
        <template #content>
          <div class="card-input-content">
            <CheckboxInput
              v-if="inputType === 'checkbox'"
              :checked="selectedItems.includes(valueOption)"
              :class="hideInputControl ? 'hidden-input' : ''"
              :focusable="false"
              :value="valueOption"
              @click.prevent="$emit('update:selected', valueOption)"
              @update:checked="val => selected = val"
            />
            <input
              v-else
              :checked="selectedItems.includes(valueOption)"
              :class="hideInputControl ? 'hidden-input' : ''"
              :disabled="disabled"
              tabindex="-1"
              type="radio"
              :value="valueOption"
              @blur="$emit('blur')"
            >
            <slot
              :label="optionLabel"
              name="card-extra"
              :value="valueOption"
            >
              {{ optionLabel }}
            </slot>
          </div>
        </template>
      </CardWrapper>
    </div>
    <slot name="errors" />
  </div>
</template>

<script>

import CardWrapper from './CardWrapper.vue'
import CheckboxInput from './CheckboxInput.vue'
import InputLabel from './InputLabel.vue'

export default {
  name: "CardInput",
  components: {
    CardWrapper,
    CheckboxInput,
    InputLabel,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    inputType: {
      type: String,
      default: 'radio',
    },
    options: {
      type: Array,
      required: true,
      validator: (options) => {
        return options.every(option => 'label' in option && 'value' in option)
      },
    },
    selectedItems: {
      type: Array,
      default: () => [],
    },
    hideInputControl: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:value', 'change', 'update:selected', 'blur'],
  methods: {
    handleSelection(value) {
      if (this.inputType === 'checkbox') {
        this.handleMultipleSelection(value)
      } else {
        this.handleSingleSelection(value)
      }
    },
    handleMultipleSelection(value) {
      const index = this.selectedItems.indexOf(value)
      if (index > -1) {
        const newSelectedItems = [ ...this.selectedItems]
        newSelectedItems.splice(index, 1)
        this.$emit('change', newSelectedItems)
        this.$emit('update:value', newSelectedItems)
      } else {
        this.$emit('change', [...this.selectedItems, value])
        this.$emit('update:value', [...this.selectedItems, value])
      }
    },
    handleSingleSelection(value) {
      this.$emit('change', [value])
      this.$emit('update:value', [value])
    },
  },
}
</script>

<style scoped>

.card-input__options-wrapper {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.card-input-content {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  font-size: 16px;
}

.hidden-input {
  display: none;
}
input[type='radio'] {
  margin: 0;
}
</style>
